import { createContext, useContext } from 'react'

import { validateContext } from 'shared/utils'

export const AvailabilitySidePanelStateContext = createContext({})
export const AvailabilitySidePanelActionsContext = createContext({})

const useAvailabilitySidePanelState = () => validateContext(useContext(AvailabilitySidePanelStateContext), {
  contextName: 'AvailabilitySidePanelStateContext',
  providerName: 'AvailabilitySidePanelProvider'
})

export const useAvailabilitySidePanelActions = () => validateContext(useContext(AvailabilitySidePanelActionsContext), {
  contextName: 'AvailabilitySidePanelActionsContext',
  providerName: 'AvailabilitySidePanelProvider'
})

export const useAvailabilitySidePanel = () => {
  const state = useAvailabilitySidePanelState()
  const actions = useAvailabilitySidePanelActions()

  return {
    ...state,
    ...actions
  }
}
